import type { SkillId } from '@rsvjelle/game-core';

export const SKILL_ICONS: Record<SkillId, string> = {
  Attack: '⚔️', Strength: '💪', Defence: '🛡️', Ranged: '🏹', Prayer: '🙏', Magic: '✨',
  Runecrafting: '🔮', Construction: '🏗️', Constitution: '❤️', Agility: '🏃', Herblore: '🧪',
  Thieving: '🗝️', Crafting: '🧵', Fletching: '🪶', Slayer: '🐲', Farming: '🌾', Hunter: '🦌',
  Mining: '⛏️', Smithing: '🔨', Fishing: '🎣', Cooking: '🍲', Firemaking: '🔥', Woodcutting: '🪓',
  Divination: '🌌', Dungeoneering: '🏰', Invention: '⚙️', Archaeology: '🏺', Summoning: '🦅'
};

export const SKILL_GROUPS: Array<{ label: string; skills: SkillId[] }> = [
  { label: 'Combat', skills: ['Attack', 'Strength', 'Defence', 'Constitution', 'Ranged', 'Magic', 'Prayer', 'Slayer'] },
  { label: 'Gathering', skills: ['Woodcutting', 'Mining', 'Fishing', 'Farming', 'Hunter', 'Archaeology', 'Divination'] },
  { label: 'Artisan', skills: ['Smithing', 'Cooking', 'Firemaking', 'Crafting', 'Fletching', 'Herblore', 'Construction', 'Runecrafting'] },
  { label: 'Adventure', skills: ['Agility', 'Thieving', 'Dungeoneering', 'Invention', 'Summoning'] }
];

export function formatNumber(value: number, maximumFractionDigits = 1): string {
  if (!Number.isFinite(value)) return '0';
  if (Math.abs(value) < 1_000) return value.toLocaleString('en-GB', { maximumFractionDigits });
  const units = [
    { value: 1e15, suffix: 'Qa' }, { value: 1e12, suffix: 'T' },
    { value: 1e9, suffix: 'B' }, { value: 1e6, suffix: 'M' }, { value: 1e3, suffix: 'K' }
  ];
  const unit = units.find((candidate) => Math.abs(value) >= candidate.value)!;
  return `${(value / unit.value).toFixed(value >= unit.value * 100 ? 0 : 1)}${unit.suffix}`;
}

export function titleCase(value: string): string {
  return value.replace(/(^|[-_\s])(\w)/g, (_, prefix: string, character: string) => `${prefix ? ' ' : ''}${character.toUpperCase()}`).trim();
}

